<template>
  <div class="flex items-center gap-16 w-full">
    <div class="flex-1">
      <SparkInput
        v-model="searchQuery"
        name="search"
        type="text"
        placeholder="Search..."
        class="w-full"
        @blur="handleSearch"
        @keyup.enter="handleSearch"
      >
        <template #prefix>
          <i class="fas fa-search" />
        </template>
      </SparkInput>
    </div>
    <div class="flex items-center gap-8">
      <!-- <SparkButton variant="outlined" class="h-40" @click="handleFilter">
        <i class="fas fa-filter mr-8" />
        Filter
      </SparkButton> -->
      <SparkButton variant="secondary" class="h-40" @click="handleAddGroup">
        <i class="fas fa-plus mr-8" />
        Add group
      </SparkButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import SparkInput from '@/components/SparkComponents/SparkInput.vue';
import SparkButton from '@/components/SparkComponents/SparkButton.vue';

const emit = defineEmits<{
  (e: 'search', value: string): void;
  (e: 'filter'): void;
  (e: 'add-group'): void;
}>();

const searchQuery = ref<string>('');

const handleSearch = () => {
  emit('search', searchQuery.value);
};

const handleFilter = () => {
  emit('filter');
};

watch(searchQuery, newVal => {
  if (newVal.length === 0) {
    handleSearch();
  }
});

const handleAddGroup = () => {
  emit('add-group');
};
</script>
